// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnergySavingPatternSelector_container__gmpN1 {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.EnergySavingPatternSelector_container__gmpN1 button {
  height: 38px;
}

.EnergySavingPatternSelector_select-wrapper__j2MFq {
  position: relative;
}

.EnergySavingPatternSelector_status__vHTHo {
  color: white;
  position: absolute;
  display: flex;
  align-items: center;
  right: 3rem;
  top: 0.5rem;
  height: calc(100% - 1rem);
  padding: 4px;
  border-radius: 6px;
}
.EnergySavingPatternSelector_status__vHTHo[data-success=true] {
  background-color: #BCCF00;
}
.EnergySavingPatternSelector_status__vHTHo[data-success=false] {
  background-color: lightcoral;
}
.EnergySavingPatternSelector_status__vHTHo {
  animation: EnergySavingPatternSelector_transient-bubble-animation__kug41 3s ease-in-out forwards;
}

@keyframes EnergySavingPatternSelector_transient-bubble-animation__kug41 {
  0% {
    opacity: 0;
  }
  15% {
    opacity: 1;
  }
  85% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.EnergySavingPatternSelector_pattern-row__LIYGg {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  align-items: start;
}
.EnergySavingPatternSelector_pattern-row__LIYGg:not(:last-child) {
  border-bottom: 1px solid #E8E8E8;
  padding-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/EnergySaving/EnergySavingPatternSelector.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAAF;AAEE;EACE,yBAAA;AAAJ;AAGE;EACE,4BAAA;AADJ;AAfA;EAmBE,gGAAA;AADF;;AAIA;EACE;IACE,UAAA;EADF;EAGA;IACE,UAAA;EADF;EAGA;IACE,UAAA;EADF;EAGA;IACE,UAAA;EADF;AACF;AAIA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;AAFF;AAME;EACE,gCAAA;EACA,oBAAA;AAJJ","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.container button {\n  height: 38px;\n}\n\n.select-wrapper {\n  position: relative;\n}\n\n.status {\n  color: white;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  right: 3rem;\n  top: 0.5rem;\n  height: calc(100% - 1rem);\n  padding: 4px;\n  border-radius: 6px;\n}\n.status[data-success=true] {\n  background-color: #BCCF00;\n}\n.status[data-success=false] {\n  background-color: lightcoral;\n}\n.status {\n  animation: transient-bubble-animation 3s ease-in-out forwards;\n}\n\n@keyframes transient-bubble-animation {\n  0% {\n    opacity: 0;\n  }\n  15% {\n    opacity: 1;\n  }\n  85% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.pattern-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2rem;\n  align-items: start;\n}\n.pattern-row:not(:last-child) {\n  border-bottom: 1px solid #E8E8E8;\n  padding-bottom: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EnergySavingPatternSelector_container__gmpN1`,
	"select-wrapper": `EnergySavingPatternSelector_select-wrapper__j2MFq`,
	"status": `EnergySavingPatternSelector_status__vHTHo`,
	"transient-bubble-animation": `EnergySavingPatternSelector_transient-bubble-animation__kug41`,
	"pattern-row": `EnergySavingPatternSelector_pattern-row__LIYGg`
};
export default ___CSS_LOADER_EXPORT___;
